export { default } from './ProjectesFinancatsMarato';
